/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EnRix.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuEn from "../../assets/component/HomepageMenuEn/HomepageMenuEn.js";

class EnRix extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="EnRix-view">
        <Helmet>
          <title>Founders - Rix Lai - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuEn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="EnRix-first">
          <Link to="/EnTeam">
            <div className="EnRix-back">
              <div className="EnRix-backBtn"></div>
              <div className="EnRix-backText">Back</div>
            </div>
          </Link>

          <div className="EnRixContainer">
            <div className="EnRix-rixPic" />

            <div className="EnRix-name">
              <strong>Rix Lai </strong>
              <br />
              Founder and Technology Advisor
            </div>
          </div>
        </div>

        <div className="EnRix-second">
          <div className="EnRix-secondText">
            Rix Lai is the Founder of CheckPlus.
            <p />
            Rix understands the importance of using the right technologies on
            the right projects.
            <p />
            Before he became the Founder of CheckPlus, he spent most of his time
            learning how to code from a young age. With his expertise and
            experience in the technology field, he worked with the Product
            Development Team at CheckPlus during the early days.
            <p />
            Rix earned a Bachelor of Science in Computer Science from the
            University of California, San Diego.
          </div>
        </div>

        <div className="EnRix-footer">
          <div className="EnRix-footerNav">
            <Link to="/EnTeam">
              <div className="EnRix-footerNavItem">Our Founders</div>
            </Link>
            <Link to="/EnFaq">
              <div className="EnRix-footerNavItem">FAQ</div>
            </Link>
            <Link to="/EnContact">
              <div className="EnRix-footerNavItem">Contact Us</div>
            </Link>

            <Link to="/EnPrivacyPolicy">
              <div className="EnRix-footerNavItem">Privacy Policy</div>
            </Link>

            <Link to="/EnTerms">
              <div className="En-footerNavItem">Terms and Conditions</div>
            </Link>
          </div>

          <div className="EnRix-footer_text">
            Flat A, 5/F, Wah Lee Industrial Building
            <br />
            11 Sze Shan Street, Yau Tong, Kowloon, Hong Kong
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. All Rights Reserved.
          </div>
        </div>
      </div>
    );
  }
}

export default EnRix;
